import { Button, Col, Form, Input, InputPicker } from 'rsuite';
import TextField from '../../../components/form/textfield';
import { useCallback, useEffect, useRef, useState } from 'react';
import { FlexboxGrid } from 'rsuite';
import Field from '../../../components/form/field';
import TextAreaField from '../../../components/form/textarea-field';
import { faIR } from 'date-fns-jalali/locale';
import { format } from 'date-fns-jalali';
import { DatePicker } from '../../../components/form/datepicker/datepicker';
import { showToast } from '../../../utils/toast';
import { handlePostConsultantEducationBackground } from '../../../api-handler';
import {
  PostConsultantEducationBackgroundModel,
  defaultConsultantEducationBackgroundFormValue,
  defaultConsultantEducationBackgroundSchema
} from '../../../models';
import { getRandomId } from '../../../utils/helpers';
import { useNavigate } from 'react-router-dom';

export const EducationBackgroundForm = (props: {
  currentDoing: boolean;
  readonly?: boolean;
  handleAddDoingData: (newData: PostConsultantEducationBackgroundModel, isCurrent: boolean) => void;
  defaultValue?: PostConsultantEducationBackgroundModel | null;
  hideNextButton?: boolean;
  forceReadOnly?: boolean;
  disabledMode?: boolean;
}) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formRef = useRef<any>(null);
  const [formError, setFormError] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formValue, setFormValue] = useState<any>(
    props.defaultValue ?? defaultConsultantEducationBackgroundFormValue
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [timeStamp, setTimeStamp] = useState<any>(new Date());
  const [calendarOpen, setCalendarOpen] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [timeStampEnd, setTimeStampEnd] = useState<any>(new Date());
  const [calendarEndOpen, setCalendarEndOpen] = useState(false);

  const handleSubmit = useCallback(
    async (isNext: boolean) => {
      if (formRef.current && !formRef.current.check()) {
        console.log('formError', formError);
        return;
      }

      if (!formValue) return;
      const payload = {
        ...formValue,
        StudyNow: props.currentDoing,
        Start_Date: timeStamp,
        End_Date: timeStampEnd,
        Country: 'ایران'
      };
      console.log(payload);
      if (!props.currentDoing) {
        if (!payload.End_Date) {
          setFormError((pre) => {
            return { ...pre, End_Date: 'الزامی است!' };
          });
          return;
        }
      }
      setLoading(true);
      const res = await handlePostConsultantEducationBackground(payload);
      setLoading(false);
      if (res.ok) {
        showToast('فرم ثبت شد!', 'success');
        // or getting submitted data from backend
        if (isNext) {
          navigate('/consultant/consultation');
          return;
        }
        props.handleAddDoingData({ ...payload, RandomId: getRandomId() }, props.currentDoing);
        setFormValue(defaultConsultantEducationBackgroundFormValue);
        // todo: navigate to next step
      }
    },
    [formValue, formError, timeStamp, timeStampEnd, formRef, props.currentDoing]
  );

  useEffect(() => {
    console.log('asddas');
    if (props.defaultValue) {
      // setTimeStamp(new Date(props.defaultValue.Start_Date) ?? new Date());
      // setTimeStampEnd(new Date(props.defaultValue.End_Date) ?? new Date());
    }
  }, [props?.defaultValue, props?.defaultValue]);

  return (
    <Form
      ref={formRef}
      onChange={setFormValue}
      onCheck={setFormError}
      formError={formError}
      model={defaultConsultantEducationBackgroundSchema}
      onSubmit={() => handleSubmit(false)}
      formValue={formValue}
      checkTrigger="change"
      className="mt-6 text-dark"
      readOnly={props.forceReadOnly ?? loading}
      disabled={props.disabledMode}>
      <FlexboxGrid
        className={`${!props.currentDoing ? 'bg-[--rs-primary-50] rounded-md border-[1px] border-[--rs-primary-500] p-3' : null} `}>
        <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={16} className="max-w-[100%] !px-0">
          <FlexboxGrid>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} className="max-w-[100%]">
              <TextField
                name="Name"
                label={props.currentDoing ? 'نام محل تحصیل فعلی' : 'نام محل تحصیل'}
                type="text"
                accepter={Input}
                dir="rtl"
                full
                placeholder=""
                req
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} className="max-w-[100%]">
              <Field
                accepter={InputPicker}
                data={[{ label: 'مقطع 1', value: 'مقطع 1' }]}
                name="Grade"
                label="مقطع"
                dir="rtl"
                full
                req
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>

            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
              <Field
                name="Country"
                label="کشور"
                accepter={InputPicker}
                data={[{ label: 'ایران', value: 'ایران' }]}
                dir="rtl"
                full
                defaultValue="ایران"
                disabled
                req
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
              <Field
                name="State"
                label="استان"
                accepter={InputPicker}
                data={[{ label: 'استان 1', value: 'استان 1' }]}
                dir="rtl"
                full
                req
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%]">
              <Field
                name="City"
                label="شهر"
                accepter={InputPicker}
                data={[{ label: 'شهر 1', value: 'شهر 1' }]}
                dir="rtl"
                full
                req
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} className="max-w-[100%]">
              <Field
                name="Field"
                label="رشته تحصیلی"
                accepter={InputPicker}
                data={[{ label: 'رشته 1', value: 'رشته 1' }]}
                dir="rtl"
                full
                req
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} className="max-w-[100%]">
              <Field
                name="Orientation"
                label="گرایش"
                accepter={InputPicker}
                data={[{ label: 'رشته 1', value: 'گرایش 1' }]}
                dir="rtl"
                full
                req
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>
            {/* todo: */}

            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} className="max-w-[100%]">
              <div style={{ position: 'relative' }}>
                <TextField
                  className="font-fd cursor-pointer mb-4"
                  name="Start_Date"
                  type="text"
                  dir="rtl"
                  full
                  accepter={Input}
                  readOnly
                  value={format(timeStamp, 'dd MMMM yyyy', { locale: faIR })}
                  label="تاریخ شروع"
                  req
                  onClick={props.readonly ? () => null : () => setCalendarOpen((state) => !state)}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: 60,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 1000
                  }}>
                  <DatePicker
                    onSelectDate={setTimeStamp}
                    defaultDate={timeStamp}
                    open={calendarOpen}
                    setOpen={setCalendarOpen}
                    hideTime
                    hideToday
                    hideConfirm
                  />
                </div>
              </div>
            </FlexboxGrid.Item>

            {!props.currentDoing ? (
              <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={12} className="max-w-[100%]">
                <div style={{ position: 'relative' }}>
                  <TextField
                    className="font-fd cursor-pointer mb-4"
                    name="End_Date"
                    type="text"
                    dir="rtl"
                    full
                    accepter={Input}
                    readOnly
                    value={format(timeStampEnd, 'dd MMMM yyyy', { locale: faIR })}
                    label="تاریخ پایان"
                    req
                    onClick={
                      props.readonly ? () => null : () => setCalendarEndOpen((state) => !state)
                    }
                  />
                  <div
                    style={{
                      position: 'absolute',
                      top: 60,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      zIndex: 1000
                    }}>
                    <DatePicker
                      onSelectDate={setTimeStampEnd}
                      defaultDate={timeStampEnd}
                      open={calendarEndOpen}
                      setOpen={setCalendarEndOpen}
                      hideTime
                      hideToday
                      hideConfirm
                    />
                  </div>
                </div>
              </FlexboxGrid.Item>
            ) : null}
          </FlexboxGrid>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={8} className="max-w-[100%] !px-0">
          <FlexboxGrid>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={24} className="max-w-[100%]">
              <TextAreaField
                name="Address"
                label={props.currentDoing ? 'آدرس محل تحصیل فعلی' : 'آدرس محل تحصیل'}
                dir="rtl"
                full
                req
                rows={5}
                placeholder="آدرس را بدون ذکر شهر و استان نوشته و با ، جدا کنید."
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={24} className="max-w-[100%]">
              <TextAreaField
                name="Description"
                label={'توضیحات'}
                dir="rtl"
                full
                req
                rows={5}
                placeholder=""
                readOnly={props.readonly}
              />
            </FlexboxGrid.Item>
          </FlexboxGrid>
        </FlexboxGrid.Item>
      </FlexboxGrid>

      {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing */}
      {props.readonly || props.disabledMode ? null : (
        <>
          <div className="flex justify-between">
            <Button
              appearance="primary"
              className="ml-auto mt-4"
              type="button"
              onClick={() => handleSubmit(false)}
              loading={loading}>
              {props.hideNextButton ? 'ثبت تحصیل فعلی' : 'افزودن سابقه جدید'}
            </Button>
          </div>
          {props.hideNextButton ? null : (
            <div className="flex justify-between">
              <Button
                appearance="default"
                className="ml-auto mt-8"
                type="button"
                onClick={() => {
                  navigate('/consultant/work');
                  // showToast('اطلاعات قبلا ثبت شده', 'warning');
                }}
                loading={loading}>
                مرحله قبل
              </Button>
              <Button
                appearance="primary"
                className="mr-auto mt-8"
                type="button"
                onClick={() => handleSubmit(true)}
                loading={loading}>
                ثبت و مرحله بعد
              </Button>
            </div>
          )}
        </>
      )}
    </Form>
  );
};
